export enum Action {
  AddClaim = "addClaim",
  DetailClaim = "detailClaim",
  DetailPolicy = "detailPolicy",
  DownloadAllClaim = "downloadAllClaim",
  DownloadAllClaimV2 = "downloadAllClaimV2",
  DownloadAllPolicy = "downloadAllPolicy",
  DownloadAllPolicyV2 = "downloadAllPolicyV2",
  GetProductCodeList = "getProductCodeList",
  GetPartnershipUploadPolicyPresignUrl = "getPartnershipUploadPolicyPresignUrl",
  GetPartnershipUploadClaimPresignUrl = "getPartnershipUploadClaimPresignUrl",
  HitPresignUrl = "hitPresignUrl",
  ListClaim = "listClaim",
  ListClaimsHistoriesClaim = "listClaimsHistoriesClaim",
  ListPolicy = "listPolicy",
  ListPartners = "listPartners",
  UpdateClaim = "updateClaim",
  UpdateBulkClaim = "updateBulkClaim",
  SearchClaim = "searchClaim",
  StoreProduct = "storeProduct",
  FetchProductList = "fetchProductList",
  FetchCategoryList = "fetchCategoryList",
  GetClaimPresignUrl = "getClaimPresignUrl",
  GetProductCategoryList = "getProductCategoryList",
  GetStoplossList = "getStoplossList",
  GetClaimFormList = "getClaimFormList",
  GetClaimFormDetail = "getClaimFormDetail",
  GetClaimLogList = "getClaimLogList",
  SharePolicy = "sharePolicy",
  CreateInvoice = "createInvoice",
  SummaryInvoice = "summaryInvoice",
  GetProductGroupList = "getProductGroupList",
  ListInvoice = "listInvoice",
  DetailInvoice = "detailInvoice",
  CancelInvoice = "cancelInvoice",
  ResendPaymentLink = "resendPaymentLink",
  HistoryInvoice = "historyInvoice",
  SummaryInvoicePayment = "summaryInvoicePayment",
  MarkAsPaidInvoice = "markAsPaidInvoice",
  ListClaimDisbursement = "listClaimDisbursement",
  DetailClaimDisbursement = "detailClaimDisbursement",
  HistoryClaimDisbursement = "historyClaimDisbursement",
  UpdateStatusClaimDisbursement = "updateStatusClaimDisbursement",
  CreateClaimDisbursement = "createClaimDisbursement",
  SummaryClaimDisbursement = "summaryClaimDisbursement",
  SummaryDisbursementPayment = "summaryDisbursementPayment",
  MarkAsPaidDisbursement = "markAsPaidDisbursement",
  CancelClaimDisbursement = "cancelClaimDisbursement",
  ListClaimPool = "listClaimPool",
  DetailClaimPool = "detailClaimPool",
  HistoryClaimPool = "historyClaimPool",
  RetryPayment = "retryPayment",
  ListNotificationTemplate = "listNotificationTemplate",
  CreateNotificationTemplate = "createNotificationTemplate",
  PostProductDetail = "postProductDetail",
  OcrInvoicePhoto = "ocrInvoicePhoto",
  CreateQuotation = "createQuotation",
  ProductVersionList = "productVersionList",
  GadgetListCatalog = "gadgetListCatalog",
  ListGadgetCategory = "listGadgetCategory",
  ListBrand = "listBrand",
}

export enum Getter {
  GetClaim = "getClaim",
  GetClaims = "getClaims",
  GetClaimsHistoriesClaim = "getClaimsHistoriesClaim",
  GetClaimsMeta = "getClaimsMeta",
  GetPartners = "getPartners",
  GetPolicy = "getPolicy",
  GetPolicies = "getPolicies",
  GetPoliciesMeta = "getPoliciesMeta",
  GetUploadProgress = "getUploadProgress",
  isMicroHealth = "isMicroHealth",
  isFinance = "isFinance",
  isTravel = "isTravel",
  isGadget = "isGadget",
  GetInvoices = "getInvoices",
  GetInvoicesMeta = "getInvoicesMeta",
  GetInvoice = "getInvoice",
  GetInvoicesHistories = "getInvoicesHistories",
  GetClaimsDisbursement = "getClaimDisbursement",
  GetClaimsDisbursementMeta = "getClaimsDisbursementMeta",
  GetClaimDisbursementDetail = "getClaimDisbursementDetail",
  GetClaimDisbursementHistories = "getClaimDisbursementHistories",
  GetClaimPools = "getClaimPools",
  GetClaimPoolsMeta = "getClaimPoolsMeta",
  GetClaimPool = "getClaimPool",
  GetGadgets = "getGadgets",
  GetGadgetsMeta = "getGadgetsMeta",
  GetGadgetsAll = "getGadgetsAll",
  GetGadgetCategory = "getGadgetCategory",
  GetListBrand = "getListBrand",
}

export enum Mutation {
  SetClaim = "setClaim",
  SetClaimList = "setClaimList",
  SetClaimListMeta = "setClaimListMeta",
  SetClaimHistory = "setClaimHistory",
  SetPolicy = "setPolicy",
  SetPolicyList = "setPolicyList",
  SetPolicyListMeta = "setPolicyListMeta",
  SetPartnerList = "setPartnerList",
  SetUploadProgress = "setUploadProgress",
  SetProduct = "setProduct",
  SetProductList = "setProductList",
  SetCategoryList = "setCategoryList",
  SetInvoiceList = "setInvoiceList",
  SetInvoiceListMeta = "setInvoiceListMeta",
  SetInvoice = "setInvoice",
  SetInvoiceHistory = "setInvoiceHistory",
  SetClaimDisbursementList = "setClaimDisbursementList",
  SetClaimDisbursementDetail = "setClaimDisbursementDetail",
  SetClaimDisbursementListMeta = "setClaimDisbursementListMeta",
  SetClaimDisbursementHistory = "setClaimDisbursementHistory",
  SetClaimPoolList = "setClaimPoolList",
  SetClaimPoolListMeta = "setClaimPoolListMeta",
  SetClaimPool = "setClaimPool",
  mutationGadgets = "mutationGadgets",
  mutationGadgetsAll = "mutationGadgetsAll",
  mutationGadgetsMeta = "mutationGadgetsMeta",
  mutationGadgetCategory = "mutationGadgetCategory",
  mutationListBrand = "mutationListBrand",
}
